/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'locked': {
    width: 22,
    height: 25,
    viewBox: '0 0 22 25',
    data: '<path pid="0" _fill="#9398a2" d="M22 8.543V25H0V8.543h4V6.9C4 3.095 7.14 0 11 0s7 3.095 7 6.9v1.643zm-16 0h10V6.9c0-2.718-2.243-4.929-5-4.929S6 4.182 6 6.9zm14 1.971H2V23.03h18zM7.667 15.786h6.666v1.971H7.667z"/>'
  }
})
